import { Link } from 'react-router-dom';
import Avatar from '../images/avatar';

export default function AvatarLink({
  username,
  avatarUrl,
  source,
  isInternal,
}: {
  username: string;
  avatarUrl: string;
  source: string;
  isInternal: boolean;
}) {
  return (
    <>
      {isInternal && (
        <Link to={`/${username}`}>
          <Avatar url={avatarUrl} size="base" alt={username || ''} />
        </Link>
      )}
      {!isInternal && (
        <a href={source} target="_blank" rel="noreferrer">
          <Avatar url={avatarUrl} size="base" alt={username || ''} />
        </a>
      )}
    </>
  );
}
